import { useStore } from "app/stores";
import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import CustomerJourneySeriesTimeline from "./Component/CustomerJourneySeriesTimeline";
const ListCustomerJourneyTab = () => {
  const { t } = useTranslation();

  const { listCustomerJourney } =
    useStore().patientManagementStore.customerJourneyTabStore;
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <CustomerJourneySeriesTimeline items={listCustomerJourney} />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListCustomerJourneyTab));
